import { CommonError, DisabledOpacity, MockupLoader } from "components/utils";
import { DrawerRightPanel, RightPanelSection } from "components/utils/drawer";
import { useQuery } from "hooks";
import { useEffect, useState } from "react";
import { PanelHeader } from "./components/PanelHeader";
import { useProductQuery } from "hooks/apiPrimitives";

interface Props {
  close: () => void;
}

export const RightPanel = ({ close }: Props) => {
  const { query } = useQuery();
  const { panelId } = query;
  const [isScrolledOver, setIsScrolledOver] = useState(false);
  const { data: product, error, isLoading } = useProductQuery(panelId, {
    enabled: Boolean(panelId),
  });

  useEffect(() => {
    setIsScrolledOver(false);
  }, [panelId]);

  if (error) {
    return (
      <DrawerRightPanel>
        <CommonError status={error._httpStatus_} />
      </DrawerRightPanel>
    );
  }

  if (isLoading) {
    return (
      <DrawerRightPanel>
        <MockupLoader type="drawer" />
      </DrawerRightPanel>
    );
  }

  if (!product) return null;

  return (
    <DrawerRightPanel key={product.id}>
      <PanelHeader
        product={product}
        panelId={panelId}
        close={close}
        isScrolledOver={isScrolledOver}
      />
      <DisabledOpacity disabled={isLoading}>
        <RightPanelSection>
          <div className="fs-24">{product.name}</div>
        </RightPanelSection>
      </DisabledOpacity>
    </DrawerRightPanel>
  );
};
